// Staff avatar (photo or initials) with a live status dot.
import { BACKEND_URL_PUBLIC } from "./squadUtils";

export const STATUS = {
  active: { label: "Active", dot: "bg-emerald-400", text: "text-emerald-300", ring: "ring-emerald-400/60" },
  brb: { label: "BRB", dot: "bg-amber-400", text: "text-amber-300", ring: "ring-amber-400/60" },
  offline: { label: "Offline", dot: "bg-slate-500", text: "text-slate-400", ring: "ring-white/10" },
};

export function initials(name = "") {
  const p = name.replace(/\(.*?\)/g, "").trim().split(/\s+/).filter(Boolean);
  return p.length ? (p[0][0] + (p[1]?.[0] || "")).toUpperCase() : "?";
}

export function avatarSrc(url) {
  if (!url) return null;
  return `${BACKEND_URL_PUBLIC}${url}&auth=${encodeURIComponent(localStorage.getItem("talmia_token") || "")}`;
}

export default function SquadAvatar({ name, url, status, size = 40, testid }) {
  const s = STATUS[status];
  const src = avatarSrc(url);
  const dot = Math.max(8, Math.round(size / 4));
  return (
    <span className="relative inline-block shrink-0" style={{ width: size, height: size }} data-testid={testid}>
      {src ? (
        <img src={src} alt={name} className={`w-full h-full rounded-full object-cover ring-2 ${s ? s.ring : "ring-white/10"} ${status === "offline" ? "grayscale opacity-60" : ""}`} />
      ) : (
        <span className={`w-full h-full rounded-full grid place-items-center font-display font-bold bg-[#16213a] text-slate-100 ring-2 ${s ? s.ring : "ring-white/10"} ${status === "offline" ? "opacity-60" : ""}`}
          style={{ fontSize: Math.round(size * 0.36) }}>{initials(name)}</span>
      )}
      {s && <span className={`absolute bottom-0 right-0 rounded-full border-2 border-[#0F1A30] ${s.dot}`} style={{ width: dot, height: dot }} />}
    </span>
  );
}
